<template>
	<div class="z-box-wrap">
		<ul class="head">
			<li>历史消息</li>
		</ul>
	
		<div class="main">
			<div class="tab-div">
				<div class="search-head">
					<span>消息日期：</span>
					<el-date-picker class="top-choose" v-model="time_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="time_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<div class='front-btn green shift'  @click="search()">查询</div>
				</div>

				<div class="list">
					<div class="list-head">
						<div>消息时间</div>
						<div>消息简讯</div>
						<div>消息状态</div>
					</div>	
					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in data_list" :key="item.id">
							<div>{{ item.created_at }}</div>
							<div class="overhide" :title="item.message">{{ item.message }}</div>
							<div>{{ item.status | text }}</div>
						</div>
					</z-scrollDiv>	
				</div>

				<z-pagination class="inside" @getPage="search" :data='history_data'></z-pagination>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState } from "vuex";


	export default {
		data() {
			return {
                time_start:"",
                time_end:"",
                history_data:{},
            }
		},

		computed:{
            ...mapState(["picker_special"]),
            data_list(){
                return this.history_data.list;
            },
        },
        
        filters:{
            text(status){
                switch (status) {
                    case 1:
                        return "未读"
                    case 2:
                        return "已读"
                }
            }
        },

		created(){
			this.fresh();
		},

		methods: {
			fresh(obj = {}){  //拉取数据
				if(typeof obj == "function"){
					func = obj;
					obj = {};
				}

				let url = "api/websocket/msg/user/all";
				let config = {params:obj};
				this.$http.get(url,config).then(res=>{
					if(res.status == 200){
                        this.history_data = res.res_data;
					}
				});
			},
			search(page){   //查询数据
				let obj = {
					page:page,
					start_date:this.time_start,
					end_date:this.time_end,
				}
				this.fresh(obj);
			},
		}
	}
</script>

<style lang="less" scoped>
	@import "~src/assets/less/var.less";
	@import "~src/assets/less/application.less";

	.list-head >div,.list-detail .item>div{
        &:nth-of-type(1){
            width: 15%;
        }
        &:nth-of-type(2){
			width: 35%;
        }
        &:nth-of-type(3){
            width: 15%;
		}
		// &:nth-of-type(4){
        //     width: 15%;
		// }
	}

	// .list-detail .item>div{
	// 	&:last-of-type{
	// 		color: @focus-c;
	// 		cursor:pointer;
	// 	}
	// }

	// .z-box-wrap{
	// 	height: calc(~"100% - @{front_head_h} - 2*@{front_padd}");  //减去头部高 margin
	// 	margin:@front_padd;
	// }

	.red{
		color:@red;
	}
</style>





// WEBPACK FOOTER //
// page-info-history.vue?2ce7e6c8